exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-mobile-chart[data-v-22dd6a2e]{height:100%;padding:.5rem}", ""]);

// exports
